import React from 'react';
import { Box } from '@mui/material';
import walletIcon from '../../../assets/images/wallet.jpg';

const ConcentricRings = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: { xs: 135, sm: 155, md: 165, lg: 160, xl: 185 },
          height: { xs: 135, sm: 155, md: 165, lg: 160, xl: 185 },
          flexShrink: 0,
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="-12 -12 245 239"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          shapeRendering="geometricPrecision"
        >
          {/* Center building graphic from branchPopulation.svg */}
          <g transform="translate(80.484, 77.5)">
            <image
              href={walletIcon}
              x="0"
              y="0"
              width="60"
              height="60"
              clipPath="url(#avatarClip)"
              preserveAspectRatio="xMidYMid slice"
            />
          </g>

          {/* Inner ring — spins CW 5s */}
          <g>
            <animateTransform attributeName="transform" type="rotate" from="0 110.484 107.5" to="360 110.484 107.5" dur="5s" repeatCount="indefinite" />
            <path d="M110.483 53.5C141.196 53.5 166.024 77.7151 166.024 107.5C166.024 137.285 141.196 161.5 110.483 161.5C79.7705 161.5 54.9434 137.285 54.9434 107.5C54.9434 77.7152 79.7705 53.5002 110.483 53.5Z" stroke="url(#paint4_linear_845_3207)" strokeWidth="3" />
            <ellipse cx="163.413" cy="90" rx="6.16652" ry="6" fill="#6956E5" />
          </g>

          {/* Middle ring — spins CCW 8s */}
          <g>
            <animateTransform attributeName="transform" type="rotate" from="0 110.484 107.5" to="-360 110.484 107.5" dur="8s" repeatCount="indefinite" />
            <path d="M192.282 101.354C195.926 145.356 162.213 183.97 116.889 187.523C71.566 191.076 31.9337 158.211 28.2903 114.209C24.6469 70.2067 58.3607 31.5925 103.684 28.0397C149.007 24.4871 188.639 57.3517 192.282 101.354Z" stroke="url(#paint5_linear_845_3207)" strokeWidth="3" />
            <ellipse cx="95.5811" cy="186" rx="6.16652" ry="6" fill="#FB896B" />
          </g>

          {/* Outer ring — spins CW 13s */}
          <g>
            <animateTransform attributeName="transform" type="rotate" from="0 110.484 107.5" to="360 110.484 107.5" dur="13s" repeatCount="indefinite" />
            <path d="M110.483 1.5C170.712 1.5 219.467 48.9963 219.467 107.5C219.467 166.004 170.712 213.5 110.483 213.5C50.2545 213.5 1.5 166.004 1.5 107.5C1.5 48.9963 50.2545 1.50007 110.483 1.5Z" stroke="url(#paint6_linear_845_3207)" strokeWidth="3" />
            <ellipse cx="9.24953" cy="68" rx="6.16652" ry="6" fill="#F8C07F" />
          </g>

          <defs>
            <clipPath id="avatarClip">
              <circle cx="30" cy="30" r="30" />
            </clipPath>
            <linearGradient id="paint0_linear_486_15691" x1="8.40009" y1="51.5999" x2="51.5999" y2="8.40009" gradientUnits="userSpaceOnUse">
              <stop stopColor="#8A2387" />
              <stop offset="0.470588" stopColor="#E94057" />
              <stop offset="1" stopColor="#F27121" />
            </linearGradient>
            <linearGradient id="paint4_linear_845_3207" x1="98.1506" y1="107" x2="87.9116" y2="56.3883" gradientUnits="userSpaceOnUse">
              <stop stopColor="#6956E5" stopOpacity="0" /><stop offset="0.976403" stopColor="#6956E5" />
            </linearGradient>
            <linearGradient id="paint5_linear_845_3207" x1="68.1482" y1="86.7816" x2="184.121" y2="67.8498" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FB896B" stopOpacity="0" /><stop offset="1" stopColor="#FB896B" />
            </linearGradient>
            <linearGradient id="paint6_linear_845_3207" x1="42.1379" y1="47" x2="57.2272" y2="203.081" gradientUnits="userSpaceOnUse">
              <stop stopColor="#F8C07F" stopOpacity="0" /><stop offset="1" stopColor="#F8C07F" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Box>
  );
};

export default ConcentricRings;
